import { action, makeObservable, observable } from 'mobx';

import { Store } from '../../../store/store';
import { StoreNode } from '../../../store';
import { RegisterFormState } from './registerFormState';
import { RegisterPageAttachedParams } from './registerPageSchema';

type AuthRegisterPageMode = 'poster' | 'plain';

export class RegisterPageState
  extends StoreNode {

  layout: AuthRegisterPageMode = 'poster';

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      layout: observable,
      pageMounted: action,
      pageUnmounted: action,
    });
  }

  readonly form = new RegisterFormState(this.store);

  pageMounted(params: RegisterPageAttachedParams) { 
    const { query } = params;
    
    // could be nicer, but it works for now, in order to limit the amount of changes
    this.form.customerIdentifier = query?.customerIdentifier ?? null;
    this.form.customerAwsAccountId = query?.customerAwsAccountId ?? null;
    this.form.productCode = query?.productCode ?? null;
  }

  pageUnmounted() {
    this.form.reset();
  }
}